import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioDescriptionFn = /* @__PURE__ */ createRecipe('radio-description', {}, [])

const radioDescriptionVariantMap = {}

const radioDescriptionVariantKeys = Object.keys(radioDescriptionVariantMap)

export const radioDescription = /* @__PURE__ */ Object.assign(memo(radioDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioDescription',
  __getCompoundVariantCss__: radioDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioDescriptionVariantKeys,
  variantMap: radioDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioDescriptionVariantKeys)
  },
  getVariantProps: radioDescriptionFn.getVariantProps,
})